import { useNavigate } from 'react-router-dom';
import ROUTERS from '../../../commons/constans/router';
import SwiperSlide from "./../../../commons/components/Slider";
import { ReactComponent as IconPlayBtn } from '../../../assets/images/album/icon_play-btn.svg'
import { ReactComponent as ThumnailRecommend } from '../../../assets/images/thumnailRecommend.svg'

const VideoItem = ({video}) => {
  const navigate = useNavigate();

  const handleDetailVideo = () => {
    navigate(ROUTERS.VIDEO_RECOMMEND_PLAYER_PATH(video?.file?.id || null), {state: {prevPath: 'prevPath'}});
  }
  return (
    <div className="box-recommended-video__content">
      <div className="slide-box">
        <div className="slide-box__thumbnail-video" onClick={handleDetailVideo}>
          <img
            className="thumbnail-img"
            src={video.file?.photo_url}
            alt=""
          />
          <div className="icon-play">
            <IconPlayBtn />
          </div>
          <div className="box-text">
            <h4 className="box-text__title">{video.title}</h4>
            {video.reaction_content && 
              <div className="box-text__bg-content">
                <p className="text-truncate m-0">{video.reaction_content}</p>
                {/*<div className="text-truncate" dangerouslySetInnerHTML={{__html: video.reaction_content}} />*/}
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

const RecommendedVideo = ({videos}) => {
  const navigate = useNavigate()

  const redirectToAlbum = () => {
    navigate(ROUTERS.ALBUM + '?type=video_message')
  }
  
  return (
    <div className={`box-recommended-video ${process.env.REACT_APP_DISABLED_RECOMMEND_VIDEO_MESSAGE === 'true' ? "box-recommended-video-coming-soon" : ''}`}>
      <div className={`${process.env.REACT_APP_DISABLED_RECOMMEND_VIDEO_MESSAGE === 'true' ? "box-coming-soon" : ''}`}>
        <div className="box-recommended-video__header">
          <div className="flex-header">
            <div className="left">
              <h3 className="title-character">추천 영상편지</h3>
            </div>
            {/* <div className="icon-character" onClick={redirectToAlbum}>
              <img src="/images/icon_nextpage_w.svg" alt="" />
            </div> */}
          </div>
          <p className="check-character">
            다른 친구들의 영상편지도 구경해보세요!
          </p>
        </div>
        {
          process.env.REACT_APP_DISABLED_RECOMMEND_VIDEO_MESSAGE === 'true' 
          ? <div className="video-message-marker mb-0 pt-0">
              <div className="video-coming-soon">
                <ThumnailRecommend />
              </div>
          </div>
          : <div className="video-message-marker mb-0 pt-0">
            <div className="swiper-pagination__maker">
              <SwiperSlide
                spaceBetween={10}
                slidesPerView={1}
                pagination={true}
                children={videos.map((video, key) => <VideoItem key={key} video={video} />)}
                classSlider="swiper-pagination__custom"
              />
            </div>
          </div>
        }
      </div>
    </div>
  )
}

export default RecommendedVideo
